export const themePath = '/wp-content/themes/touchbistro4';
